export default __webpack_public_path__ + "static/media/02_Auctioneers-Commercial-EschweilerPhotography_M1A0876.47e980d0.jpg";